package com.appsyde.shared.modules.auth.domain.model

sealed class DomainError {
    data object NotAuthenticated : DomainError()
    data object InsufficientScopes : DomainError()
    data class Api(val code: String, val requestId: String? = null, val message: String? = null) : DomainError()
    data class Unknown(val message: String? = null) : DomainError()
}

sealed class DomainResult<out T> {
    data class Success<T>(val value: T) : DomainResult<T>()
    data class Failure(val error: DomainError) : DomainResult<Nothing>()
}

inline fun <T> T.asSuccess(): DomainResult<T> = DomainResult.Success(this)
